const SESSION_STORAGE_KEY = 'pendingReferralCode'

/**
 * Referral links (/referral?token=, /referral-redemption?ref_code=) drop the
 * visitor into the regular home/login flow, which loses the query string well
 * before they reach the sign up form. The code is parked here on the way in and
 * read back when the account is created, so the referrer still gets credit.
 *
 * Session storage rather than local storage: the code should not outlive the
 * tab and get attached to an unrelated sign up later on.
 */
// The code is interpolated straight into the redemption request path, so only
// accept something that can actually be a code. URLSearchParams hands back a
// decoded value, which would otherwise let a crafted link put `../` in there.
const REFERRAL_CODE_PATTERN = /^[A-Za-z0-9_-]{1,64}$/

export const getReferralCodeFromQuery = searchParams => {
  const referralCode = searchParams?.get('token') || searchParams?.get('ref_code')

  return referralCode && REFERRAL_CODE_PATTERN.test(referralCode) ? referralCode : undefined
}

export const storePendingReferralCode = referralCode => {
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, referralCode)
  } catch (ex) {
    // Storage can be unavailable (private browsing, blocked cookies). The code
    // still works for the current page load via redux.
  }
}

export const getPendingReferralCode = () => {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEY) || undefined
  } catch (ex) {
    return undefined
  }
}

export const clearPendingReferralCode = () => {
  try {
    sessionStorage.removeItem(SESSION_STORAGE_KEY)
  } catch (ex) {
    // Nothing to do.
  }
}
